const ApiSolides = require('./sdk/src/index');
const Swal = require('sweetalert2');

const firebase = require("firebase/app");
const firebaseConfig = {
    apiKey: "AIzaSyB7H0nx_NuHhf5Wu3q4rE52BlsdmpvI-WI",
    authDomain: "mmhospitalar.firebaseapp.com",
    databaseURL: "https://mmhospitalar.firebaseio.com",
    projectId: "mmhospitalar",
    storageBucket: "mmhospitalar.appspot.com",
    messagingSenderId: "738443883741",
    appId: "1:738443883741:web:930d3779be29b1a34cd734",
    measurementId: "G-RNPD3KDLME"
};

// 
firebase.initializeApp(firebaseConfig);
firebase.analytics();

// const jQuery = require("jQuery");
// window.$ = window.jQuery = jQuery; // notice the definition of global variables here
// import('jquery-mask-plugin');

import 'babel-polyfill'

import('jquery').then(async function(jquery) {
  
  $ = window.$ = window.jQuery = jquery;
  
  await import('jquery-mask-plugin');  

  $(function() {
    //
    $('.cpf').mask('000.000.000-00', { reverse: true });
    //
    $('.date').mask('00/00/0000');
    //
    var SPMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    spOptions = {
        onKeyPress: function (val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
        }
    };

    $('input[type="tel"]').mask(SPMaskBehavior, spOptions);
});

});

var defaultClient = ApiSolides.ApiClient.instance;
defaultClient.defaultHeaders = {
    "Access-Control-Allow-Origin": "*"
};
defaultClient.basePath = "https://system.solides.com/pt-BR/api/v1";

// Configure API key authorization: APIKeyHeader
var APIKeyHeader = defaultClient.authentications['APIKeyHeader'];
APIKeyHeader.apiKey = 'b6b0e373e5c92c5e7c38c068d20a41f473c257eecd741f9ce65b';
APIKeyHeader.apiKeyPrefix = 'Token';

var Api = new ApiSolides.CurrculosApi(); // Allocate the API class we're goin

const Form = document.querySelector('form');

Form.addEventListener('submit', (e) => {
    e.preventDefault();
    new FormData(Form); // construct a FormData object, which fires the formdata event    
});

Form.addEventListener('formdata', (e) => {
    
    const Button = document.querySelector('.btn-send');
    Button.innerHTML = "Enviando...";

    let data = Object.fromEntries(e.formData);
    data.disabledPerson = false;
    
    data.academicEducations = [];    
    data.academicEducations.push({
        "course": data.AE0course,
        "institution": data.AE0institution,
        "startDate": data.AE0startDate,
        "endDate": data.AE0endDate,
    });
    data.academicEducations.push({
        "course": data.AE1course,
        "institution": data.AE1institution,
        "startDate": data.AE1startDate,
        "endDate": data.AE1endDate,
    });

    data.professionalExperiences = [];
    data.professionalExperiences.push({
        "position": data.PE0position,
        "company": data.PE0company,
        "startDate": data.PE0startDate,
        "endDate": data.PE0endDate,
    });
    data.professionalExperiences.push({
        "position": data.PE1position,
        "company": data.PE1company,
        "startDate": data.PE1startDate,
        "endDate": data.PE1endDate,
    });
    data.professionalExperiences.push({
        "position": data.PE2position,
        "company": data.PE2company,
        "startDate": data.PE2startDate,
        "endDate": data.PE2endDate,
    });
    
    let academicEducationsError = '';
    let professionalExperiencesError = '';

    data.academicEducations.forEach(function(el, i){
        if(el.course == '' && el.startDate == '' && el.institution == '' && el.endDate == '') {
            delete data.academicEducations[i];
        } else if((el.course == '' || el.startDate == '') && (el.institution != '' || el.endDate != '')) {
            academicEducationsError = "Se preenchido, Nome do Curso e Data de início são obrigatórios em formação acadêmica";
        }
    });

    data.professionalExperiences.forEach(function(el, i){
        if(el.position == '' && el.startDate == '' && el.company == '' && el.endDate == '') {
            delete data.professionalExperiences[i];
        } else if((el.position == '' || el.startDate == '') && (el.company != '' || el.endDate != '')) {
            professionalExperiencesError = "Se preenchido, Cargo e Data de início são obrigatórios em experiência profissional";
        }
    });

    if(academicEducationsError || professionalExperiencesError) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            html: academicEducationsError + '<br>' + professionalExperiencesError
        })
        Button.innerHTML = "Enviar";
    } else {
        Api.addCurriculo(data, function(error, data, response) {
            if (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: JSON.parse(response.text).messages,
                })
            } else if(typeof response === 'undefined') {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: "Erro ao enviar os dados",
                })
            } else {
                Swal.fire({
                    title: 'Obrigado',
                    text: 'Cadastro realizado com sucesso',
                    type: 'success'
                });
                Form.reset();
            }
            Button.innerHTML = "Enviar";
        });
    }

});
